import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectAppCached = (store: StoreSchema) => store.application.cachedApp